var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { minute } from "../utils/constraints";
import { useHeartbeats } from "../utils/hooks";
export var UseHeartbeats = function (_a) {
    var page = _a.page, data = _a.data, _b = _a.frequency, frequency = _b === void 0 ? minute : _b;
    useHeartbeats(__assign({ from: page, type: "heartbeat" }, data), frequency);
    return null;
};
//# sourceMappingURL=HooksWrapper.js.map